import { logWarn } from 'lib/logging'

/**
 * `table` is the unscheduled-treatment board's third view, remembered under
 * the pipeline's own id (`system:treatment`) rather than a queue's, so it can
 * never come back as the answer for a queue that has no table to show.
 */
export type QueueView = `focus` | `board` | `table`

const key = (userId: string | undefined, queueId: string) => `action-center:view:${userId ?? `anon`}:${queueId}`

/**
 * How this person last worked this queue. Local on purpose: what a board
 * records about a patient is shared, how someone likes to look at it is
 * theirs. `fallback` is the queue's own default, not this helper's.
 */
export function preferredView(userId: string | undefined, queueId: string, fallback: QueueView = `focus`): QueueView {
  try {
    const stored = localStorage.getItem(key(userId, queueId))
    return stored === `board` || stored === `focus` || stored === `table` ? stored : fallback
  } catch (err) {
    logWarn(`action-center`, `Failed to read view preference from localStorage`, err)
    return fallback
  }
}

export function rememberView(userId: string | undefined, queueId: string, view: QueueView): void {
  try {
    localStorage.setItem(key(userId, queueId), view)
  } catch (err) {
    // A full or blocked store costs a preference, never the work.
    logWarn(`action-center`, `Failed to persist view preference to localStorage`, err)
  }
}
